import React from "react";
import styles from "./EditListingPage.module.css";
import EditListingForm from "../../components/EditListingForm/EditListingForm";
import NavBar from "../../components/NavBar/NavBar";

export default function EditListingPage() {
    return (
        <div>
        <NavBar/>
        <div className={styles.pageWrapper}>
            <div className={styles.contentBox}>
        <h1 className={styles.title}>Edit Your Listing</h1>
        <EditListingForm/>
        </div>
        </div>
        </div>
    )
}